import * as environment from '../../config/environment.json';

const levels = { debug: 0, info: 1, warn: 2, error: 3 };
const threshold = environment.debug ? levels.debug : levels.warn;

export function getLogger(name) {
  const logAt = level => (...args) => {
    if (levels[level] >= threshold) console[level](`${level.toUpperCase()} [${name}]`, ...args);
  };
  return { debug: logAt('debug'), info: logAt('info'), warn: logAt('warn'), error: logAt('error') };
}
